const AboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "@id": "https://onbbits.io/about/#webpage",

  "url": "https://onbbits.io/about/",

  "name": "About ONBBITS",

  "description":
    "Learn about ONBBITS, a WhatsApp Business API and automation platform helping businesses automate conversations, engage customers, and grow through WhatsApp.",

  "isPartOf": {
    "@id": "https://onbbits.io/#website"
  },

  "about": {
    "@id": "https://onbbits.io/#organization"
  },

  "publisher": {
    "@id": "https://onbbits.io/#organization"
  }
};

export default AboutPageSchema;